import { WordBankPage } from "@/pages/word/WordBankPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/words/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <WordBankPage />;
}
